import { Box, Flex, Heading, Img, Text, Button } from "@chakra-ui/react";
import { FC } from "react";
import { Helmet } from "react-helmet";
import img from "assets/img/fundo2.jpeg";
import { useAuth0 } from "@auth0/auth0-react";

const JobsPage: FC = () => {
  const { user: userAuth, logout } = useAuth0();

  return (
    <>
      <Helmet>
        <title>manutencao - AGENDAMENTO</title>
      </Helmet>
      <Box bg="white" h="100vh" overflowY="auto" color="gray.800">
        <Flex
          flexDir="column"
          alignItems="center"
          justifyContent="center"
          bg="white.600"
          borderRadius="8px"
          h="calc(100vh - 8px)"
          p={6}
        >
          <Img src={img} width={["60%", "60%", "50%"]}></Img>
          <Heading
            mb={5}
            textAlign="center"
            fontSize={["40px", "40px", "50px"]}
            fontWeight="800"
            color="green.600"
          >
            Aguarde enquanto processamos <br></br> os dados
          </Heading>
          <Text
            maxW="460px"
            fontSize="18px"
            textAlign="center"
            fontWeight="800"
            color="white"
          ></Text>
          <Text
            maxW="460px"
            fontSize="18px"
            textAlign="center"
            fontWeight="bold"
            color="green.600"
          >
            Por enquanto, tente atualizar a página ou aguarde por alguns
            minutos.
          </Text>
          <Box pt={5}>
            <Button
              _hover={{ bg: "none" }}
              _focus={{ bg: "none" }}
              bg="green.200"
              color="white"
              borderRadius="8px"
              px="14px"
              onClick={() => logout({ returnTo: window.location.origin })}
            >
              <Text fontSize="sm">Sair</Text>
            </Button>
          </Box>
        </Flex>
      </Box>
    </>
  );
};

export default JobsPage;
